__turbopack_context__.v({
  "donation-confirm-social-link": "styles-module__9oatnW__donation-confirm-social-link",
});
